<template>
  <div
    class="divide-ontick-steel-500 border-ontick-steel-300 dark:bg-ontick-graphite-500 flex flex-col space-y-4 divide-y rounded-lg border-2 p-4 dark:border-none"
  >
    <div class="flex flex-col space-y-4">
      <div class="flex flex-col space-y-1">
        <h3
          class="text-ontick-carbon-900 text-2xl font-bold dark:text-gray-300"
        >
          Dados do titular do cartão
        </h3>
      </div>
      <div class="flex flex-col space-y-4">
        <ontick-input-component
          label="Nome do pagador"
          placeholder="Nome do titular do cartão"
          name="name"
          bg="bg-transparent dark:bg-ontick-steel-500 disabled:bg-ontick-steel-300 disabled:border-0"
          shadow="shadow-none"
          v-validate="'required'"
          v-model="payer.name"
          :disabled="useUserData"
        />
        <ontick-input-component
          label="CPF"
          placeholder="000.000.000-00"
          name="cpf"
          bg="bg-transparent dark:bg-ontick-steel-500 disabled:bg-ontick-steel-300 disabled:border-0"
          shadow="shadow-none"
          v-model="payer.cpf"
          mask="###.###.###-##"
          :disabled="useUserData"
        />
        <ontick-input-component
          v-if="payer.cnpj"
          label="CNPJ"
          placeholder="00.000.000/0000-00"
          name="cnpj"
          bg="bg-transparent dark:bg-ontick-steel-500 disabled:bg-ontick-steel-300 disabled:border-0"
          shadow="shadow-none"
          v-model="payer.cnpj"
          mask="###.###.###-##"
          :disabled="useUserData"
        />
      </div>
    </div>
    <div class="flex flex-col space-y-4 pt-4">
      <h4 class="text-ontick-carbon-900 font-bold dark:text-gray-300">
        Endereço
      </h4>
      <div class="grid grid-cols-2 gap-4">
        <ontick-input-component
          label="CEP"
          placeholder="00000-000"
          name="cep"
          bg="bg-transparent dark:bg-ontick-steel-500 disabled:bg-ontick-steel-300 disabled:border-0"
          shadow="shadow-none"
          v-validate="'required|length:9'"
          v-model="payer.address.cep"
          mask="#####-###"
          :disabled="useUserData"
          :customError="invalidCep ? 'CEP não encontrado' : null"
          :loading="addressIsLoading"
          @keyup.native="getCep(payer.address.cep)"
        />
        <ontick-input-component
          label="Número"
          placeholder="1000"
          name="number"
          bg="bg-transparent dark:bg-ontick-steel-500 disabled:bg-ontick-steel-300 disabled:border-0"
          shadow="shadow-none"
          v-validate="'required|numeric'"
          v-model="payer.address.number"
          :disabled="useUserData"
        />
        <ontick-input-component
          class="col-span-full"
          label="Rua"
          placeholder="Nome da rua"
          name="street"
          bg="bg-transparent dark:bg-ontick-steel-500 disabled:bg-ontick-steel-300 disabled:border-0"
          shadow="shadow-none"
          v-validate="'required'"
          v-model="payer.address.street"
          :disabled="useUserData"
        />
        <div class="col-span-full grid grid-cols-5 gap-4">
          <ontick-input-component
            class="col-span-full sm:col-span-2"
            label="Bairro"
            placeholder="Nome do bairro"
            name="neighborhood"
            bg="bg-transparent dark:bg-ontick-steel-500 disabled:bg-ontick-steel-300 disabled:border-0"
            shadow="shadow-none"
            v-validate="'required'"
            v-model="payer.address.neighborhood"
            :disabled="useUserData"
          />
          <ontick-input-component
            class="col-span-3 sm:col-span-2"
            label="Cidade"
            placeholder="Nome da cidade"
            name="city"
            bg="bg-transparent dark:bg-ontick-steel-500 disabled:bg-ontick-steel-300 disabled:border-0"
            shadow="shadow-none"
            v-validate="'required'"
            v-model="payer.address.city"
            :disabled="useUserData"
          />
          <ontick-input-component
            class="col-span-2 sm:col-span-1"
            label="UF"
            placeholder="Ex.: SP"
            name="state"
            bg="bg-transparent dark:bg-ontick-steel-500 disabled:bg-ontick-steel-300 disabled:border-0"
            shadow="shadow-none"
            v-validate="'required'"
            v-model="payer.address.state"
            mask="AA"
            :disabled="useUserData"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import OntickInputComponent from "../../../shared/components/basic/ontick-input.component.vue";
import axios from "axios";
import EventBus from "../../../shared/utils/event_bus";

export default {
  components: {
    OntickInputComponent,
  },

  props: {
    useUserData: {
      type: Boolean,
    },
  },

  data() {
    return {
      payer: {
        name: null,
        cpf: null,
        cnpj: null,
        address: {
          cep: null,
          number: null,
          street: null,
          neighborhood: null,
          city: null,
          state: null,
        },
      },
      user: {
        name: null,
        cpf: null,
        cnpj: null,
        address: {
          cep: null,
          number: null,
          street: null,
          neighborhood: null,
          city: null,
          state: null,
        },
      },
      invalidCep: null,
      addressIsLoading: false,
    };
  },

  methods: {
    ...mapActions({
      setPayerValidationFields: "payment/setPayerValidationFields",
      setPayerData: "payment/setPayerData",
    }),

    getUserInfo() {
      return this.$api.get(this.$endpoint.GET_USER_INFO).then((res) => {
        const data = res.data;
        this.user = {
          name: data.user_name,
          cpf: data.user_cpf || null,
          cnpj: data.user_cnpj || null,
          address: {
            cep: data.user_cep,
            number: data.user_address_number,
            street: data.user_address,
            neighborhood: data.user_neighborhood,
            city: data.user_city,
            state: data.user_state,
          },
        };
      });
    },
    getCep(zipCode) {
      if (zipCode.length === 9) {
        if (/^[0-9]{5}-[0-9]{3}$/.test(zipCode)) {
          let new_code = "";
          new_code = zipCode.replace("-", "");
          this.addressIsLoading = true;
          axios
            .get(`https://viacep.com.br/ws/${new_code}/json/`)
            .then((res) => {
              if (res.data.erro) {
                this.invalidCep = true;
                EventBus.$emit("INVALID_CEP", this.invalidCep);
              } else {
                if (!this.useUserData) {
                  this.payer.address.street = res.data.logradouro;
                  this.payer.address.neighborhood = res.data.bairro;
                  this.payer.address.city = res.data.localidade;
                  this.payer.address.state = res.data.uf;
                }
                this.invalidCep = false;
                EventBus.$emit("INVALID_CEP", this.invalidCep);
              }
            })
            .catch((err) => {
              console.error(err);
            })
            .finally(() => {
              this.addressIsLoading = false;
            });
        }
      }
    },
  },

  watch: {
    useUserData: {
      immediate: true,
      handler(val) {
        if (val) {
          this.payer = this.user;
        } else {
          this.payer = {
            name: null,
            cpf: null,
            address: {
              cep: null,
              number: null,
              street: null,
              neighborhood: null,
              city: null,
              state: null,
            },
          };
        }
      },
    },

    payer: {
      deep: true,
      immediate: true,
      handler(val) {
        this.setPayerData(val);
      },
    },

    "payer.address.state": {
      handler(val) {
        if (val?.length) {
          this.payer.address.state = val.toUpperCase();
        }
      },
    },

    fields: {
      immediate: true,
      deep: true,
      handler(val) {
        this.setPayerValidationFields(val);
      },
    },
  },

  created() {
    this.getUserInfo().then(() => {
      if (this.useUserData) {
        this.payer = this.user;
      }
    });
    EventBus.$on("INVALID_CEP", (value) => {
      this.invalidCep = value;
    });
  },
};
</script>

<style></style>
